import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import BaseEffect from '../../../domain/entities/BaseEffect';

export default function reducer(
  state: {[key: number]: BaseEffect} = {},
  action: AnyAction,
): {[key: number]: BaseEffect} {
  switch (action.type) {
    case Types.IndexBaseEffectsSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (obj: {[key: number]: BaseEffect}, record: BaseEffect) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowBaseEffectSuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
